// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  text-align: center;
  font-weight: 700;
  color: rgb(54, 54, 54);
  padding-top: 24px;
}

.widget-container {
  padding: 24px;
  height: calc(90vh - 20px);
  overflow: auto;
  text-align: justify;
}

.sub-header {
  font-weight: 700;
  color: rgb(54, 54, 54);
  padding-right: 10px;
  text-transform: uppercase;
}

.system-name {
  color: rgb(105, 105, 105);
  text-transform: uppercase;
}

.divider {
  margin-top: 20px;
  border-top: 1px solid #bbb;
}

.description .desc-header {
  font-size: 12pt;
  font-weight: 600;
  color: #404040;
}
.description .desc-content {
  color: rgb(105, 105, 105);
}

.widget-header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}
.widget-header em {
  color: var(--primary);
}
.widget-header .widget-title {
  color: #5f5f5f;
  font-weight: 700;
  text-transform: uppercase;
}

.widget-card {
  margin: 10px 0px 10px 0px;
}

.tooltip-graph {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 500px;
  height: 500px;
  text-align: center;
}

.data-failure {
  padding: 64px 0;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
}

.loader-icon {
  content: var(--loader);
  position: absolute;
  top: 40%;
  left: 45%;
  opacity: 1;
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/app/auto-cx/components/auto-cx-reports/auto-cx-report-view/auto-cx-report-view.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,0BAAA;AACJ;;AAGI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAEI;EACI,yBAAA;AAAR;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AADJ;AAGI;EACI,qBAAA;AADR;AAGI;EACI,cAAA;EACA,gBAAA;EACA,yBAAA;AADR;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAFJ;;AAKA;EACE,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AAFF","sourcesContent":["h2 {\n    text-align: center;\n    font-weight: 700;\n    color: rgb(54, 54, 54);\n    padding-top: 24px;\n}\n\n.widget-container {\n    padding: 24px;\n    height: calc(90vh - 20px);\n    overflow: auto;\n    text-align: justify;\n}\n\n.sub-header {\n    font-weight: 700;\n    color: rgb(54, 54, 54);\n    padding-right: 10px;\n    text-transform: uppercase;\n}\n\n.system-name {\n    color: rgb(105, 105, 105);\n    text-transform: uppercase;\n}\n\n.divider {\n    margin-top: 20px;\n    border-top: 1px solid #bbb;\n}\n\n.description {\n    .desc-header {\n        font-size: 12pt;\n        font-weight: 600;\n        color: #404040;\n    }\n    .desc-content {\n        color: rgb(105, 105, 105);\n    }\n}\n\n.widget-header {\n    display: flex;\n    align-items: center;\n    padding-bottom: 10px;\n\n    em {\n        color: var(--primary);\n    }\n    .widget-title {\n        color: #5f5f5f;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n}\n\n.widget-card {\n    margin: 10px 0px 10px 0px;\n}\n\n.tooltip-graph {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 500px;\n    height: 500px;\n    text-align: center;\n}\n\n.data-failure {\n    padding: 64px 0;\n    text-align: center; \n    font-size: 15px;\n    font-weight: 400;\n}\n\n.loader-icon {\n  content: var(--loader);\n  position: absolute;\n  top: 40%;\n  left: 45%;\n  opacity: 1;\n  z-index: 9999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
